import { api } from '../../lib/api';
import type { AccountRow, IgFetch, PlanRow } from '../../lib/instagramBackfill/plan';

export type BackfillAccountsResponse = { accounts: AccountRow[]; profileCount: number };

export function getBackfillAccounts(): Promise<BackfillAccountsResponse> {
  return api<BackfillAccountsResponse>('/api/instagram-backfill/accounts');
}

export type FetchChunkResponse = {
  results: Array<{ pageId: string; result: IgFetch }>;
  remaining: string[];
};

/**
 * ⚠️ The token rides the BODY of a POST and nowhere else — never a query
 * string, never a header we might log, never persisted. The caller holds it in
 * component state and drops it when the run ends.
 */
export function fetchChunk(token: string, pageIds: string[]): Promise<FetchChunkResponse> {
  return api<FetchChunkResponse>('/api/instagram-backfill/fetch', {
    method: 'POST',
    body: JSON.stringify({ token, pageIds }),
  });
}

export type ApplyOutcome = 'set' | 'name-only' | 'noop' | 'raced-differs' | 'missing' | 'skip' | 'failed';

export type ApplyChunkResponse = {
  idWrites: number;
  nameOnlyWrites: number;
  skipped: number;
  failed: number;
  outcomes: Array<{ accountId: string; outcome: ApplyOutcome; error?: string }>;
};

export function applyChunk(runId: string, rows: PlanRow[], overwriteAccountIds: string[]): Promise<ApplyChunkResponse> {
  return api<ApplyChunkResponse>('/api/instagram-backfill/apply', {
    method: 'POST',
    body: JSON.stringify({
      runId,
      rows: rows.map((r) => ({
        id: r.id,
        name: r.name,
        action: r.action,
        currentIgId: r.currentIgId,
        currentIgName: r.currentIgName,
        fetchedIgId: r.fetchedIgId,
        fetchedIgUsername: r.fetchedIgUsername,
      })),
      overwriteAccountIds,
    }),
  });
}
